<div class="sam-margin">
   <div class="k-block k-bg-warning" style="padding: 0.5em" *ngIf="isSkillUnderstaffedWithoutAgent$ | async">
      <h3>
         {{ 'notification.required_agents.signout_warning_title' | translate }}
      </h3>
      <p>{{ 'notification.required_agents.signout_warning_message' | translate }}</p>
      <ul>
         <li *ngFor="let skill of understaffedSkillsWithoutAgent$ | async">
            <p *ngIf="!(skill.subSkills.length >= 2)">
               {{ skill.skillName }}
               {{
                  'notification.required_agents.x_active_agents_required'
                     | translate: { requiredAgents: skill.requiredAgents }
               }}
            </p>
            <p *ngIf="skill.subSkills.length >= 2">
               {{ skill.skillName }}
            </p>
            <ul *ngIf="skill.subSkills.length >= 2">
               <li *ngFor="let subskill of skill.subSkills">
                  {{ subskill?.skillName }}
                  {{
                     'notification.required_agents.x_active_agents_required'
                        | translate: { requiredAgents: subskill.requiredAgents }
                  }}
               </li>
            </ul>
         </li>
      </ul>
   </div>
   <h3 class="sam-margin">{{ 'common.authentication.sign_out.confirmation_title' | translate }}</h3>
   <div class="sam-margin close-current-session">
      <button
         kendoButton
         [primary]="true"
         (click)="signOutCurrentSession()"
         [disabled]="isLogoutDisabled$ | async"
         class="sam-full-width"
      >
         <fa-icon class="sam-margin-right" [icon]="signOutIcon"></fa-icon>
         <div class="sam-button-text">
            {{ 'common.authentication.sign_out.close_current_session_button' | translate }}
         </div>
      </button>
   </div>
   <div class="sam-margin close-all-sessions" *ngIf="multipleActiveSessions$ | async">
      <button kendoButton (click)="signOutAllSessions()" [disabled]="isLogoutDisabled$ | async" class="sam-full-width">
         <fa-icon class="sam-margin-right" [icon]="closeAllSessionsIcon"></fa-icon>
         <div class="sam-button-text">
            {{ 'common.authentication.sign_out.close_all_sessions_button' | translate }}
         </div>
      </button>
   </div>
</div>
